import { render } from "./NoDataFound.vue?vue&type=template&id=623e7888&scoped=true"
import script from "./NoDataFound.vue?vue&type=script&lang=js"
export * from "./NoDataFound.vue?vue&type=script&lang=js"

import "./NoDataFound.vue?vue&type=style&index=0&id=623e7888&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623e7888"]])

export default __exports__